import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../lib/i18n";
import { waLink, PHONE_TEL } from "../lib/api";

export default function FloatingContact() {
    const { t, lang } = useLang();
    return (
        <div className="fixed bottom-5 right-4 sm:right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
            <motion.a
                initial={{ opacity: 0, scale: 0.6, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
                href={waLink(t.waMsg.simple[lang])}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-whatsapp-btn"
                aria-label="WhatsApp"
                className="group flex items-center gap-2.5 rounded-full bg-[#25D366] pl-4 pr-5 py-3.5 text-white shadow-xl shadow-emerald-900/30 hover:shadow-2xl hover:brightness-105 transition-all duration-300 hover:-translate-y-0.5"
            >
                <MessageCircle size={22} className="shrink-0 transition-transform duration-300 group-hover:scale-110" />
                <span className="text-sm font-bold tracking-wide hidden sm:inline">WhatsApp</span>
            </motion.a>
            <motion.a
                initial={{ opacity: 0, scale: 0.6, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ delay: 1.35, type: "spring", stiffness: 260, damping: 18 }}
                href={`tel:${PHONE_TEL}`}
                data-testid="floating-phone-btn"
                aria-label={t.common.call}
                className="group flex items-center gap-2.5 rounded-full bg-forest-800 pl-4 pr-5 py-3.5 text-white shadow-xl shadow-emerald-900/30 hover:shadow-2xl hover:bg-forest-700 transition-all duration-300 hover:-translate-y-0.5"
            >
                <Phone size={20} className="shrink-0 transition-transform duration-300 group-hover:rotate-12" />
                <span className="text-sm font-bold tracking-wide hidden sm:inline">5920 0029</span>
            </motion.a>
        </div>
    );
}